import Vue from 'vue'
import DataDict from '@/utils/dict2'
import { getSysDictionary } from '@/api/src/bigData'

function install() {
  Vue.use(DataDict, {
    metas: {
      '*': {
        labelField: 'value',
        valueField: 'code',
        request(dictMeta) {
          return getSysDictionary(dictMeta.type).then(res => res.data)
        },
      },
    },
  })
}

export default {
  install,
}